import { GridHeaderCellProps } from '@progress/kendo-react-grid';

const AttachmentIconHeader = (props: GridHeaderCellProps) => (
  <span className="k-cell-inner" title={'File Icon'}>
    <span className="k-link w-fit" onClick={props.onClick}>
      <span className="k-column-title k-icon k-i-attachment k-i-clip" />
      {props.children}
    </span>
  </span>
);

export default AttachmentIconHeader;
